import { differenceInCalendarDays, format, parseISO } from "date-fns";
import { fr, enUS } from "date-fns/locale";

export const MAX_DAYS = 90;
export const isDaily = (product) => product?.unit === "day";
export const toISO = (d) => format(d, "yyyy-MM-dd");
export const rentalDays = (start, end) =>
  start && end ? differenceInCalendarDays(parseISO(end), parseISO(start)) + 1 : 0;
export const fmtDate = (iso, lang) => format(parseISO(iso), "d MMM yyyy", { locale: lang === "fr" ? fr : enUS });
export const dateLocale = (lang) => (lang === "fr" ? fr : enUS);
